import { IkasProductImage } from ".";

export function initIkasProductImage(productImage: IkasProductImage) {
  productImage.image = productImage.imageId
    ? { id: productImage.imageId, isVideo: productImage.isVideo || false }
    : null;
}
